<template>
  <v-slide-y-transition mode="out-in">
    <v-container class="fill-height pa-0 mt-0 chat-drawer-container fluid">      
      <template v-if="!$vuetify.breakpoint.smAndDown">
        <v-layout row>
          <v-flex lg4 class="chat-contact--sidebar white">
            <list-kompetisi :quickcountMode.sync="quickcountMode"></list-kompetisi>
          </v-flex>  
          <v-flex lg8 v-if="showArea">
            <list-area :quickcountMode.sync="quickcountMode"></list-area>
          </v-flex>
        </v-layout>
      </template>
      <template v-else>
        <v-layout column>          
          <v-flex lg12 v-if="showArea" class="chat-contact--sidebar white">
            <list-area :quickcountMode.sync="quickcountMode"></list-area>
          </v-flex>
          <v-flex lg12 v-else-if="showWindow" class="chat-contact--sidebar white">
            <list-kompetisi :quickcountMode.sync="quickcountMode"></list-kompetisi>
          </v-flex>
        </v-layout>        
      </template>
    </v-container>
  </v-slide-y-transition>  
</template>
<script>
import ListKompetisi  from './list-kompetisi';
import ListArea       from './list-area';

var _  = require('lodash');

export default {
  components: {
    ListKompetisi,
    ListArea
  },
  data () {
    return {
      //chat: null,
      //selectedTab: null,
      quickcountMode : false,
    };
  },
  computed: {
    
    showWindow () {
      return this.$route.query.kompetisi_id === undefined;
    },    
    
    showArea() {
      return this.$route.query.tingkat !== undefined;
    }
  },
};
</script>

